const ANIMATION_DURATION = 2000;
const ANIMATION_START = 99;

const reducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const animateNumberScroll = (element, finalNumber) => {
  let startTime = null;

  const animationStep = timestamp => {
    if (!startTime) startTime = timestamp;

    const progress = timestamp - startTime;
    const elapsedTime = Math.min(progress / ANIMATION_DURATION, 1);

    element.textContent = Math.max(
      ANIMATION_START -
        Math.floor(elapsedTime * (ANIMATION_START - finalNumber)),
      finalNumber,
    );

    if (progress < ANIMATION_DURATION) {
      requestAnimationFrame(animationStep);
    } else {
      element.textContent = finalNumber;
    }
  };

  requestAnimationFrame(animationStep);
};

const showPlacesCount = (placesCount, certifiedCount) => {
  const label = document.getElementById('placesCountLabel');
  const counter = document.getElementById('placesCount');

  if (label) {
    label.textContent = placesCount;
  }

  if (counter) {
    if (reducedMotion()) {
      counter.textContent = placesCount;
    } else {
      animateNumberScroll(counter, placesCount);
    }
  }

  const certifiedPartner = document.getElementById('certifiedPartner');

  if (!certifiedPartner) {
    return;
  }

  if (certifiedCount > 0) {
    const certifiedCountElement = document.getElementById('certifiedCount');

    if (certifiedCountElement) {
      certifiedCountElement.textContent = certifiedCount;
    }

    certifiedPartner.classList.remove('hidden');
  } else {
    certifiedPartner.classList.add('hidden');
  }
};

const updateTown = (bloc, citySlug) => {
  fetch('/devis/update_town', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ concerned_person_town: citySlug }),
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Town update failed: ${response.status}`);
      }

      return response.json();
    })
    .then(data => {
      // The banner reassures, it does not report a search result: a "0" right
      // above the submit button only talks the visitor out of the request.
      if (!data.success || !data.places_count) {
        bloc.classList.add('hidden');

        return;
      }

      // Filled before being revealed, so the live region announces the count
      // and its sentence in one go instead of an empty one first.
      showPlacesCount(data.places_count, data.certified_count);
      bloc.classList.remove('hidden');
    })
    .catch(error => {
      bloc.classList.add('hidden');

      if (window.Sentry) {
        window.Sentry.captureException(error, { extra: { citySlug } });
      }
    });
};

if (window.placesCountInitialized === undefined) {
  window.placesCountInitialized = true;

  const bloc = document.getElementById('placeAndPartnerBloc');
  // Scoped to the quote field: the header and the nav render their own
  // comboboxes, whose events would otherwise drive this counter too.
  const input = document.querySelector(
    '[data-city-combobox-input][name="form[concerned_person_town]"]',
  );

  if (bloc && input) {
    input.addEventListener('city-combobox:select', event =>
      updateTown(bloc, event.detail.slug || event.detail.name),
    );

    input.addEventListener('city-combobox:clear', () =>
      bloc.classList.add('hidden'),
    );
  }
}
